import { useAuthCtx } from "./useAuthCtx.ts";
import { useEffect } from "react";
import { FullPageLoading } from "../UI/FullPageLoading.tsx";

export const LogoutScreenPath = "/logout";
export function LogoutScreen() {
  const { logout } = useAuthCtx();
  useEffect(() => {
    (async () => {
      await logout();
      window.location.href = "/";
    })();
  }, [logout]);

  return <FullPageLoading />;
}
